// libs
import React, {useState} from 'react';
// components
import ConfirmationBox from '../../components/confirmation-box';
import PrintErrorMsg from '../../components/print-error-msg';
import Button from 'react-bootstrap/Button';
// config & functions 
import config from '../../config';

function Table({loadapidata, list, urlAccountId, orgInfo, token, onOpenFormModal}) {
    const [ShowDeleteModalBox, setShowDeleteModalBox] = useState(false);
    const [RowId, setRowId] = useState(0);
    const deleteUrl = `${config.api.generic}/category`;

    const handleDelete = (rowId) => {
        setRowId(rowId);
        setShowDeleteModalBox(true);
    }

    const handleUpdate = (rowId) => {
        if (onOpenFormModal) {
            onOpenFormModal(rowId);
        } else {
            setRowId(rowId);
            setShowDeleteModalBox(false);
        }
    }

    if(list && Array.isArray(list) && list.length > 0) {
        return <>
            <div className="table-responsive">
                <table className="table fs-14rem">
                    <thead>
                        <tr>
                            <th style={{minWidth: '50px'}}>#</th>
                            <th style={{minWidth: '160px'}}>Name</th>
                            <th style={{minWidth: '140px'}}>URL Slug</th>
                            <th style={{minWidth: '80px'}}>Sort</th>
                            <th style={{minWidth: '90px'}}>Products</th>
                            <th style={{minWidth: '80px'}}>Active</th>
                            <th style={{minWidth: '160px'}}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {list.map((data, i) => {
                            return <tr key={data.pk_id}>
                                <td>{i + 1}</td>
                                <td>
                                    {data.fk_parent_id ? <span className="ps-3">
                                        <span className="text-muted">{data.parent_label} › </span>{data.label}
                                    </span> : <span className="fw-bold">{data.label}</span>}
                                </td>
                                <td><code className="fs-12rem">{data.slug}</code></td>
                                <td>{data.sort_order}</td>
                                <td>{data.product_count ?? 0}</td>
                                <td>
                                    <span className={`badge ${parseInt(data.is_active) ? 'bg-success' : 'bg-secondary'}`}>
                                        {parseInt(data.is_active) ? 'Yes' : 'No'}
                                    </span>
                                </td>
                                <td>
                                    {(orgInfo.roleId === 1 || orgInfo.roleId === 2) ? <>
                                        <Button variant="secondary" onClick={() => handleUpdate(data.pk_id)} className="fs-14rem me-3 p-0 border-0 bg-transparent text-primary">Update</Button>
                                        <Button variant="secondary" onClick={() => handleDelete(data.pk_id)} className="fs-14rem p-0 border-0 bg-transparent text-danger">Delete</Button>
                                    </> : null}
                                </td>
                            </tr>
                        })}
                    </tbody>
                </table>
            </div>
            {(ShowDeleteModalBox) ? <ConfirmationBox loadapidata={loadapidata} apidataparams={null} setshowdeletemodalbox={setShowDeleteModalBox} url={deleteUrl} params={{id: RowId, accountId: urlAccountId}} token={token} /> : null}
        </>
    } else {
        return <PrintErrorMsg msg={'No categories yet. Click ADD CATEGORY to create one.'} />;
    }
}

export default Table;
